// extracted by mini-css-extract-plugin
export default {"container":"Login_container__mZo+z","card":"Login_card__UCkHv"};